import React, { useContext } from 'react';
import { Pressable, View } from 'react-native';
import { format, parseISO } from 'date-fns';
import PropTypes from 'prop-types';
import { H3, H5, H6 } from '../text';
import { Avatar } from '../common/Avatar';
import CdnImage from '../common/CdnImage';
import { fetchPage } from '../../common/Api';
import Utils from '../../common/Utils';
import LayoutContext from '../../contexts/Layout';
import AppContext from '../../contexts/App';

const NewsArticleCard = ({ author, avatar, categories = [], featured = false, image, link, releaseDate, rootPath, style, title, width }) => {
    const { dispatch } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);
    const date = format(typeof releaseDate === 'string' ? parseISO(releaseDate) : new Date(releaseDate), 'MMMM d, yyyy');

    const handleClick = async () => {
        if (rootPath) {
            await fetchPage(dispatch, Utils.cleanupInternalUrl(rootPath));
        }
    };

    const getCategories = () => {
        if (categories.length === 0) {
            return null;
        }

        const results = [];

        for (var x = 0; x < categories.length; x++) {
            const category = categories[x];

            if (x + 1 !== categories.length) {
                results.push(<H6 key={`${x}-${category}`} text={`${category}\n`} />);
            } else {
                results.push(<H6 key={`${x}-${category}`} text={`${category}`} />);
            }
        }

        return results;
    };

    return (
        <View key={title} style={[style, { width }, isNaN(width) && { background: 'red' }]}>
            <Pressable onPress={handleClick}>
                <CdnImage alt={title} uri={image.cdnImagePath} width={width} />
                <View
                    style={{ padding: layout.styleGuide.spacer2 }}
                    dataSet={{
                        spacerBottom: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`,
                        spacerLeft: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`,
                        spacerRight: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`,
                        spacerTop: `StyleGuide.Spacer2(${layout.styleGuide.spacer2})`
                    }}
                >
                    <View style={{ flexDirection: 'row' }}>
                        <H5 style={{ color: '#808080' }} text={date} />
                    </View>
                    <View
                        style={{ flexDirection: 'row', marginVertical: layout.styleGuide.spacer3 }}
                        dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})`, spacerTop: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}
                    >
                        <H3 text={String(title)} />
                    </View>
                    <View style={{ alignItems: 'center', flexDirection: 'row' }}>
                        {avatar && <Avatar imageUri={avatar.cdnImagePath} size={50} />}
                        <View>
                            <H5 text={`${author}`} />
                            <View
                                style={{ paddingVertical: layout.styleGuide.spacer4 }}
                                dataSet={{ spacerBottom: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})`, spacerTop: `StyleGuide.Spacer4(${layout.styleGuide.spacer4})` }}
                            >
                                {getCategories()}
                            </View>
                        </View>
                    </View>
                </View>
            </Pressable>
        </View>
    );
};

NewsArticleCard.propTypes = {
    author: PropTypes.string,
    avatar: PropTypes.shape({
        cndImagePath: PropTypes.string
    }),
    catagories: PropTypes.arrayOf(PropTypes.string),
    featured: PropTypes.bool,
    image: PropTypes.shape({
        cndImagePath: PropTypes.string
    }),
    index: PropTypes.number,
    link: PropTypes.shape({
        internalKey: PropTypes.string,
        externalUrl: PropTypes.string,
        isExternal: PropTypes.bool
    }),
    ministryGroup: PropTypes.arrayOf(PropTypes.string),
    releaseDate: PropTypes.string,
    rootPath: PropTypes.string,
    title: PropTypes.string
};

export default NewsArticleCard;
